// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'document-plus';

export const Component = () => (
  <path d='M22.163 6.753 15.841.431C15.602.144 15.22 0 14.788 0H3.484c-.431 0-.766.144-1.054.431A1.408 1.408 0 0 0 2 1.485v21.552c0 .431.144.766.431 1.054.288.287.623.43 1.054.43H21.11c.432 0 .767-.143 1.054-.43.288-.288.432-.623.432-1.054V7.807c0-.431-.144-.766-.432-1.054Zm-6.465-5.076 5.172 5.172h-4.645c-.335 0-.479-.144-.479-.479l-.048-4.693Zm5.939 6.178v15.182c0 .335-.192.479-.527.479H3.486c-.335 0-.527-.144-.527-.48V1.487c0-.336.192-.527.527-.527H14.74v5.41c0 .432.143.767.43 1.054a1.41 1.41 0 0 0 1.055.431h5.412-.001Zm-8.86 3.4v3.448h3.448c.335 0 .479.144.479.479 0 .335-.144.527-.479.527h-3.448v3.4c0 .335-.144.526-.48.526-.335 0-.478-.191-.478-.526v-3.4H8.37c-.335 0-.479-.192-.479-.527s.144-.479.48-.479h3.448v-3.448c0-.335.143-.48.479-.48.335 0 .479.145.479.48Z' />
);

export const viewBox = '0 0 25 25';
